import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';
import history from 'app/routes/history';
import HeaderThin from 'app/components/layout/HeaderThin';
import SectionGroup from 'app/components/general/SectionGroup';
import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import Dropzone from 'react-dropzone';
import paymentCategories from 'app/utils/static/eventTypes';

export default class StaticData extends React.Component {
  static propTypes = {
    appReady: PropTypes.bool,
    actions: PropTypes.object,
    match: PropTypes.object,
    paymentEvents: PropTypes.object,
    errors: PropTypes.object,
    handleImportStatus: PropTypes.func,
    changeFileContent: PropTypes.func,
    handleChange: PropTypes.func,
    handleDueConfigChange: PropTypes.func,
    handleSeasonChange: PropTypes.func,
    handleAmountChange: PropTypes.func,
    handleChangeTime: PropTypes.func,
    handlePaymentCategoryChange: PropTypes.func,
    handleCompetitionChange: PropTypes.func,
    amount: PropTypes.string,
    paymentCategory: PropTypes.object,
    competitions: PropTypes.array,
    competition: PropTypes.object,
    dueConfig: PropTypes.number,
    seasonTag: PropTypes.object,
    activeAt: PropTypes.string,
    planIdentifier: PropTypes.object,
    descriptionPrefix: PropTypes.string,
    isValid: PropTypes.bool,
  };

  static defaultProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    paymentEvents: undefined,
    errors: {},
    handleImportStatus: undefined,
    changeFileContent: undefined,
    handleChange: undefined,
    handleDueConfigChange: undefined,
    handleSeasonChange: undefined,
    handleAmountChange: undefined,
    handleChangeTime: undefined,
    handlePaymentCategoryChange: undefined,
    handleCompetitionChange: undefined,
    amount: undefined,
    paymentCategory: undefined,
    competitions: undefined,
    competition: undefined,
    dueConfig: undefined,
    seasonTag: undefined,
    activeAt: undefined,
    planIdentifier: undefined,
    ignoreIdentifier: undefined,
    descriptionPrefix: undefined,
    isValid: false,
  };

  state = {
    dragStatus: null,
  };

  render(): React.ReactNode {
    return (
      <SectionGroup
        title="1. Setup Import"
        className=""
        notification={this.props.paymentEvents.paymentEventSaved ? 'Saved' : ''}
      >
        <div className="row">
          <div className="col">
            <div className="form-description">
              Importing a CSV allows you to bulk add payment events into Teammo.
              These events may be matches, registration or any kind of payment
              required.
            </div>
            <div className="form-description">
              <a
                href="http://help.teammo.com.au/en/articles/3303478-importing-payment-events"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary"
              >
                Learn more
              </a>
              {' '}
              about importing data.
            </div>
            <div className="row">
              <div className="col">
                <InputGroupBlock
                  type="select"
                  labelText="Competition"
                  name="competition"
                  isMulti={false}
                  placeholder="Competition"
                  aria-label="Competition"
                  autoComplete="off"
                  tabIndex="2"
                  value={this.props.competition}
                  options={this.props.competitions}
                  onChange={this.props.handleCompetitionChange}
                />

                <InputGroupBlock
                  type="select"
                  labelText="Event Type"
                  name="paymentCategory"
                  isMulti={false}
                  placeholder="Event Type"
                  aria-label="Event Type"
                  autoComplete="off"
                  tabIndex="2"
                  value={this.props.paymentCategory}
                  options={paymentCategories}
                  onChange={this.props.handlePaymentCategoryChange}
                />

                <InputGroupBlock
                  name="amount"
                  type="currency"
                  labelText="Amount"
                  placeholder=""
                  errors={this.props.errors.amount}
                  value={this.props.amount}
                  onChange={this.props.handleAmountChange}
                />

                <InputGroupBlock
                  name="activeAt"
                  type="datetime"
                  labelText="Active Date (Date payments can come in)"
                  placeholder=""
                  errors={this.props.errors.activeAt}
                  value={this.props.activeAt}
                  onChange={this.props.handleChangeTime}
                />

                <InputGroupBlock
                  type="select"
                  labelText="Season"
                  name="paymentCategory"
                  isMulti={false}
                  placeholder="Season reference (eg. Summer 2020)"
                  aria-label="Season"
                  autoComplete="off"
                  createable
                  tabIndex="2"
                  value={this.props.seasonTag}
                  options={this.props.seasonTags}
                  onChange={this.props.handleSeasonChange}
                />

                <InputGroupBlock
                  name="dueConfig"
                  type="number"
                  min={1}
                  max={7}
                  step="1"
                  labelText="Payment Due (Days before event)"
                  placeholder="Days before event (2 is default)"
                  errors={this.props.errors.dueConfig}
                  value={this.props.dueConfig}
                  onChange={this.props.handleDueConfigChange}
                />

                <InputGroupBlock
                  name="descriptionPrefix"
                  labelText="Description Prefix"
                  placeholder="Label that shows before the description (eg. Round 1)"
                  errors={this.props.errors.descriptionPrefix}
                  value={this.props.descriptionPrefix}
                  onChange={this.props.handleChange}
                />
              </div>
            </div>

            <div className="row">
              <div className="col btn-flex-group less-padding">
                <div className="btn-flex-container">
                  <Button
                    className="btn-standard btn-1"
                    type="submit"
                    onClick={() => {
                      this.props.handleImportStatus('upload');
                    }}
                  >
                    Upload File
                  </Button>
                  <Button
                    onClick={() => history.push('/events')}
                    className="btn-standard btn-2"
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionGroup>
    );
  }
}
